<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/g8brIB/images/cover.jpg?1684514752805" alt="This image is the cover for the book The Border"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Border
      </h1>
      <p class="bookDescription body article font2">
        <p>Injured in a war that has stretched on for years, Sergeant John Peterson guards a lonely border. Aside from passing contact with railship captains, the only person he sees is the enemy: the man who guards the other side of the border. A bad fall places John’s life in the other soldier’s hands. He’s wary of his rescuer, First Lieutenant Thomas Fellowes, but over time he finds himself drawn to his new companion. Both soldiers carry the war in their souls, but they might find peace in each other.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Kim Fielding
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4c130f1a